module.exports = __webpack_public_path__ + "img/dominic.e3479cae.png";